import * as React from 'react';

export function ImageIcon({width = 11, height = 11, ...props}: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x={0.5}
                y={0.75}
                width={9.5}
                height={9.5}
                rx={1.75}
                fill="currentColor"
                fillOpacity={0.1}
                stroke="currentColor"
                strokeWidth={0.5}
            />
            <path d="M1 7l2.173-2.329a.2.2 0 01.304.014L8 10.5" stroke="currentColor" strokeWidth={0.3} />
            <circle cx={8.5} cy={4} r={1.3} stroke="currentColor" strokeWidth={0.4} />
        </svg>
    );
}
